import { PREMIUM_PLAN_ID } from 'components/billing/constants';
import { MONTHLY } from '../Constants';

export const getPremiumTrialSubscriptionIdFromPlan = (plans) => {
  const premiumPlan = plans.find(
    (plan) => plan?.identifier === PREMIUM_PLAN_ID,
  );

  const subscriptionOptionId = premiumPlan?.subscriptionOptions?.edges?.find(
    (subscriptionOption) => subscriptionOption?.node?.cycle === MONTHLY,
  )?.node?.id;

  return subscriptionOptionId;
};

export const getActivePremiumSampleFromPlan = (plans) => {
  return (
    plans?.find((plan) => plan.identifier === PREMIUM_PLAN_ID)?.activeSample ||
    false
  );
};
